import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { authService } from '../../../services/AuthenticationService';
import { mapAuthError } from '../../../utils/auth-error';
import { routes } from '../../../route-list';
import { SignupScreen } from '../components/SignupScreen';

export const SignupContainer: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onSignup = async (email: string, password: string, name?: string) => {
    setErrorMessage(null);
    setLoading(true);
    try {
      await authService.signup(email, password, name);
      // After signup, log in automatically
      await authService.loginWithPassword(email, password);
      history.replace(routes.HOME);
    } catch (e: any) {
      if (e?.code === 'email_not_verified') {
        history.push(routes.AUTH_VERIFY_EMAIL, { email });
        return;
      }
      setErrorMessage(mapAuthError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignupScreen
      loading={loading}
      errorMessage={errorMessage}
      onSignup={onSignup}
      onBackToLogin={() => history.push(routes.LOGIN)}
    />
  );
};
